/* eslint-env browser */

(function (window) {
    'use strict';

    var SIWA_SURVEY_THEME = {
        themeName: 'siwa-night-gold',
        colorPalette: 'dark',
        isPanelless: false,
        cssVariables: {
            '--sjs-font-family': 'Inter, sans-serif',
            '--sjs-font-size': '16px',
            '--sjs-font-questiontitle-family': '"Cormorant Garamond", Georgia, serif',
            '--sjs-font-questiontitle-size': '1.25rem',
            '--sjs-font-questiontitle-weight': '600',
            '--sjs-general-backcolor': 'rgba(17, 17, 20, 1)',
            '--sjs-general-backcolor-dark': 'rgba(11, 11, 12, 1)',
            '--sjs-general-forecolor': 'rgba(231, 217, 184, 1)',
            '--sjs-general-dim-forecolor': 'rgba(231, 217, 184, 0.72)',
            '--sjs-primary-backcolor': 'rgba(200, 168, 78, 1)',
            '--sjs-primary-backcolor-light': 'rgba(200, 168, 78, 0.22)',
            '--sjs-primary-backcolor-dark': 'rgba(160, 130, 50, 1)',
            '--sjs-primary-forecolor': 'rgba(11, 11, 12, 1)',
            '--sjs-primary-forecolor-light': 'rgba(11, 11, 12, 1)',
            '--sjs-secondary-backcolor': 'rgba(11, 11, 12, 1)',
            '--sjs-secondary-backcolor-light': 'rgba(17, 17, 20, 1)',
            '--sjs-secondary-forecolor': 'rgba(231, 217, 184, 1)',
            '--sjs-border-default': 'rgba(200, 168, 78, 0.28)',
            '--sjs-border-light': 'rgba(200, 168, 78, 0.12)',
            '--sjs-shadow-small': 'none',
            '--sjs-shadow-medium': 'none',
            '--sjs-shadow-large': 'none',
            '--sjs-shadow-inner': 'none',
            '--sjs-editor-background': 'rgba(11, 11, 12, 1)',
            '--sjs-question-background': 'rgba(11, 11, 12, 1)',
            '--sjs-corner-radius': '6px'
        }
    };

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.textContent = text == null ? '' : String(text);
        return div.innerHTML;
    }

    function showStatus(message, type) {
        var el = document.getElementById('siwa-onboarding-status');
        var root = document.getElementById('siwa-survey-root');
        var steps = document.getElementById('siwa-onboarding-steps');
        if (!el) {
            return;
        }
        el.hidden = false;
        el.className = 'siwa-onboarding-status siwa-alert siwa-alert-' + (type || 'info');
        el.innerHTML = '<p>' + escapeHtml(message) + '</p>';
        if (root) {
            root.hidden = true;
        }
        if (steps) {
            steps.hidden = true;
        }
    }

    function applySiwaSurveyTheme(survey) {
        survey.applyTheme(SIWA_SURVEY_THEME);
    }

    function buildStepNav(pages) {
        var nav = document.getElementById('siwa-onboarding-steps');
        if (!nav || !pages || !pages.length) {
            return;
        }

        var list = nav.querySelector('.siwa-onboarding-steps__list');
        if (!list) {
            return;
        }

        list.innerHTML = pages.map(function (page, index) {
            var label = page.title || page.name || ('Passo ' + (index + 1));
            return (
                '<li class="siwa-onboarding-steps__item" data-step="' + index + '">' +
                '<span class="siwa-onboarding-steps__index" aria-hidden="true">' + (index + 1) + '</span>' +
                '<span class="siwa-onboarding-steps__label">' + escapeHtml(label) + '</span>' +
                '</li>'
            );
        }).join('');

        nav.hidden = false;
    }

    function setActiveStep(index) {
        var items = document.querySelectorAll('.siwa-onboarding-steps__item');
        items.forEach(function (el, i) {
            el.classList.toggle('is-active', i === index);
            el.classList.toggle('is-done', i < index);
        });
    }

    var REQUIRED_TIERS = {
        personal: 'siwa-personal',
        publisher: 'siwa-publisher'
    };

    function tierDeniedMessage(onboardingType) {
        if (onboardingType === 'publisher') {
            return 'Non sei autorizzato: questa area è riservata ai membri Siwa Publisher.';
        }
        return 'Non sei autorizzato: questa area è riservata ai membri Siwa Personal.';
    }

    function draftStorageKey(onboardingType) {
        return 'siwa-onboarding:' + onboardingType;
    }

    function loadDraft(onboardingType) {
        try {
            var raw = window.localStorage.getItem(draftStorageKey(onboardingType));
            if (!raw) {
                return null;
            }
            return JSON.parse(raw);
        } catch (err) {
            return null;
        }
    }

    function saveDraft(onboardingType, survey) {
        try {
            window.localStorage.setItem(draftStorageKey(onboardingType), JSON.stringify({
                data: survey.data,
                currentPageNo: survey.currentPageNo
            }));
        } catch (err) {
            // Ignore quota or private mode errors.
        }
    }

    function clearDraft(onboardingType) {
        try {
            window.localStorage.removeItem(draftStorageKey(onboardingType));
        } catch (err) {
            // Ignore storage errors.
        }
    }

    function applyDraft(survey, draft, pageCount) {
        if (!draft || !draft.data || typeof draft.data !== 'object') {
            return;
        }

        Object.keys(draft.data).forEach(function (key) {
            if (draft.data[key] != null && draft.data[key] !== '') {
                survey.setValue(key, draft.data[key]);
            }
        });

        if (typeof draft.currentPageNo === 'number' && draft.currentPageNo >= 0) {
            var maxPage = Math.max(0, (pageCount || 1) - 1);
            survey.currentPageNo = Math.min(draft.currentPageNo, maxPage);
        }
    }

    function parseBirthDatetime(value) {
        var match = String(value || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
        if (!match) {
            return null;
        }
        return {
            year: parseInt(match[1], 10),
            month: parseInt(match[2], 10),
            day: parseInt(match[3], 10),
            hour: parseInt(match[4], 10),
            minute: parseInt(match[5], 10)
        };
    }

    function preparePersonalPayload(data) {
        var payload = Object.assign({}, data);
        var birth = parseBirthDatetime(payload.birth_datetime);

        if (!birth) {
            throw new Error('Seleziona data e ora di nascita dal calendario.');
        }

        payload.year = birth.year;
        payload.month = birth.month;
        payload.day = birth.day;
        payload.hour = birth.hour;
        payload.minute = birth.minute;

        delete payload.birth_datetime;
        delete payload.birth_hint;
        delete payload.birth_picker;
        delete payload.place_hint;
        delete payload.place_picker;
        delete payload.intro;
        delete payload.confirm_html;
        delete payload.confirm_data;

        return payload;
    }

    function normalizeSubmitPayload(data, onboardingType) {
        if (onboardingType === 'personal') {
            return preparePersonalPayload(data);
        }
        return data;
    }

    function formatBirthSummary(date) {
        if (!date) {
            return 'Selezionato: —';
        }
        return 'Selezionato: ' + date.toLocaleString('it-IT', {
            weekday: 'long',
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    }

    function defaultBirthDate() {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 28);
        date.setHours(12, 0, 0, 0);
        return date;
    }

    function getFlatpickrLocale() {
        if (window.flatpickr && window.flatpickr.l10ns && window.flatpickr.l10ns.it) {
            return window.flatpickr.l10ns.it;
        }
        return undefined;
    }

    function mountBirthDatetimePicker(survey, htmlElement) {
        if (!window.flatpickr || !survey || !htmlElement) {
            return;
        }

        var shell = htmlElement.querySelector('[data-siwa-birth-picker]');
        if (!shell || shell.dataset.siwaBirthMounted === '1') {
            return;
        }

        var calendarHost = shell.querySelector('[data-siwa-birth-calendar]');
        var summary = shell.querySelector('[data-siwa-birth-summary]');
        var birthQuestion = survey.getQuestionByName('birth_datetime');

        if (!calendarHost || !summary || !birthQuestion) {
            return;
        }

        shell.dataset.siwaBirthMounted = '1';

        var input = document.createElement('input');
        input.type = 'text';
        input.className = 'siwa-birth-datetime__input';
        shell.appendChild(input);

        var locale = getFlatpickrLocale();
        var config = {
            inline: true,
            appendTo: calendarHost,
            enableTime: true,
            time_24hr: true,
            dateFormat: 'Y-m-d H:i',
            allowInput: false,
            disableMobile: true,
            minDate: new Date(1900, 0, 1),
            maxDate: new Date(),
            defaultHour: 12,
            defaultMinute: 0,
            onChange: function (selectedDates, dateStr) {
                birthQuestion.value = dateStr;
                summary.textContent = formatBirthSummary(selectedDates[0]);
            },
            onReady: function (selectedDates, dateStr, instance) {
                if (instance.calendarContainer) {
                    instance.calendarContainer.classList.add('siwa-birth-datetime__picker');
                    instance.calendarContainer.classList.add('open');
                }
                if (selectedDates && selectedDates[0]) {
                    summary.textContent = formatBirthSummary(selectedDates[0]);
                    if (!birthQuestion.value && dateStr) {
                        birthQuestion.value = dateStr;
                    }
                }
            }
        };

        if (locale) {
            config.locale = locale;
        }
        config.defaultDate = birthQuestion.value || defaultBirthDate();

        try {
            window.flatpickr(input, config);
        } catch (err) {
            shell.dataset.siwaBirthMounted = '0';
            summary.textContent = 'Impossibile caricare il calendario. Ricarica la pagina.';
        }
    }

    function setupBirthDatetimePicker(survey) {
        if (!window.flatpickr) {
            return;
        }

        survey.onAfterRenderQuestion.add(function (sender, options) {
            if (!options.question || options.question.name !== 'birth_picker') {
                return;
            }
            mountBirthDatetimePicker(sender, options.htmlElement);
        });

        survey.onAfterRenderPage.add(function (sender, options) {
            if (!options.page || options.page.name !== 'birth') {
                return;
            }
            window.setTimeout(function () {
                var pickerQuestion = sender.getQuestionByName('birth_picker');
                if (!pickerQuestion || !pickerQuestion.id) {
                    return;
                }
                var htmlElement = document.getElementById(pickerQuestion.id);
                if (htmlElement) {
                    mountBirthDatetimePicker(sender, htmlElement);
                }
            }, 50);
        });
    }

    function resolvePrefillName() {
        return window.SiwaApp.getSessionToken()
            .then(function (token) {
                return window.SiwaApp.fetchGhostMember(token);
            })
            .then(function (member) {
                if (member && member.name) {
                    return String(member.name).trim();
                }
                return '';
            })
            .catch(function () {
                return '';
            });
    }

    function loadSurvey(root, surveyUrl, submitPath, redirectUrl, onboardingType, prefillName) {
        fetch(surveyUrl)
            .then(function (res) {
                if (!res.ok) {
                    throw new Error('Impossibile caricare il questionario');
                }
                return res.json();
            })
            .then(function (schema) {
                var survey = new window.Survey.Model(schema);
                survey.locale = 'it';
                survey.showCompletePage = false;

                var draft = loadDraft(onboardingType);
                var restoringDraft = false;

                if (draft) {
                    restoringDraft = true;
                    applyDraft(survey, draft, (schema.pages || []).length);
                    restoringDraft = false;
                }

                if (prefillName && !survey.getValue('name')) {
                    survey.setValue('name', prefillName);
                }

                applySiwaSurveyTheme(survey);
                if (onboardingType === 'personal') {
                    setupBirthDatetimePicker(survey);
                    if (window.SiwaPlacePicker) {
                        window.SiwaPlacePicker.setup(survey);
                    }
                }
                buildStepNav(schema.pages || []);
                setActiveStep(survey.currentPageNo || 0);

                survey.onValueChanged.add(function (sender) {
                    if (restoringDraft) {
                        return;
                    }
                    saveDraft(onboardingType, sender);
                });

                survey.onCurrentPageChanged.add(function (sender) {
                    setActiveStep(sender.currentPageNo);
                    saveDraft(onboardingType, sender);
                });

                survey.onCompleting.add(function (sender, options) {
                    options.allowComplete = false;
                    showStatus('Salvataggio in corso…', 'info');

                    var payload;
                    try {
                        payload = normalizeSubmitPayload(sender.data, onboardingType);
                    } catch (err) {
                        var statusEl = document.getElementById('siwa-onboarding-status');
                        var steps = document.getElementById('siwa-onboarding-steps');
                        if (statusEl) {
                            statusEl.hidden = true;
                        }
                        if (steps) {
                            steps.hidden = false;
                        }
                        root.hidden = false;
                        showStatus(err.message || 'Dati non validi.', 'error');
                        return;
                    }

                    window.SiwaApp.apiFetch(submitPath, {
                        method: 'POST',
                        body: payload
                    })
                        .then(function () {
                            clearDraft(onboardingType);
                            if (redirectUrl) {
                                window.location.href = redirectUrl;
                                return;
                            }
                            showStatus('Tema natale salvato con successo.', 'success');
                        })
                        .catch(function (err) {
                            var statusEl = document.getElementById('siwa-onboarding-status');
                            var steps = document.getElementById('siwa-onboarding-steps');
                            if (statusEl) {
                                statusEl.hidden = true;
                            }
                            if (steps) {
                                steps.hidden = false;
                            }
                            root.hidden = false;
                            showStatus(err.message || 'Errore durante il salvataggio.', 'error');
                        });
                });

                if (draft) {
                    saveDraft(onboardingType, survey);
                }

                if (window.SurveyUI && window.SurveyUI.renderSurvey) {
                    window.SurveyUI.renderSurvey(survey, root);
                } else {
                    survey.render(root);
                }
            })
            .catch(function (err) {
                showStatus(err.message || 'Errore di caricamento.', 'error');
            });
    }

    function init() {
        var root = document.getElementById('siwa-survey-root');
        if (!root) {
            return;
        }

        if (!window.SiwaApp) {
            showStatus('Errore di inizializzazione: SiwaApp non caricato. Ricarica la pagina.', 'error');
            return;
        }

        if (!window.Survey) {
            showStatus('Impossibile caricare SurveyJS. Controlla la connessione o disabilita ad blocker.', 'error');
            return;
        }

        var surveyUrl = root.getAttribute('data-survey-url');
        var submitPath = root.getAttribute('data-submit-path');
        var redirectUrl = root.getAttribute('data-redirect-url');
        var onboardingType = root.getAttribute('data-siwa-onboarding');
        var requiredTier = REQUIRED_TIERS[onboardingType];

        if (!surveyUrl || !submitPath) {
            showStatus('Configurazione onboarding incompleta.', 'error');
            return;
        }

        if (!requiredTier) {
            showStatus('Onboarding non configurato.', 'error');
            return;
        }

        window.SiwaApp.resolveMemberTier()
            .then(function (tierSlug) {
                if ((tierSlug || '') !== requiredTier) {
                    showStatus(tierDeniedMessage(onboardingType), 'error');
                    return;
                }

                var prefillPromise = onboardingType === 'personal'
                    ? resolvePrefillName()
                    : Promise.resolve('');

                return prefillPromise.then(function (prefillName) {
                    loadSurvey(root, surveyUrl, submitPath, redirectUrl, onboardingType, prefillName);
                });
            })
            .catch(function (err) {
                showStatus(err.message || 'Impossibile verificare l\'accesso.', 'error');
            });
    }

    window.SiwaOnboarding = {
        init: init
    };
})(window);
